
// Letter @72dpi - the page the reference values below were tuned on.
const REF_W = 612;
const REF_H = 792;
const REF_L = Math.sqrt(REF_W * REF_H); // 696.21

// A freshly added table may occupy at most this fraction of either page axis.
const MAX_FRACTION = 0.8;

const MIN_SCALE = 0.15;
const MAX_SCALE = 8;

// Below these a cell stops being renderable, so they are floored in absolute units.
const MIN_FONT_SIZE  = 4;
const MIN_ROW_HEIGHT = 8;
const MIN_COL_WIDTH  = 8;

const SCALE_FLOORS = {
  fontSize:  MIN_FONT_SIZE,
  colWidth:  MIN_COL_WIDTH,
  rowHeight: MIN_ROW_HEIGHT,
};

const TABLE_REF = {
  colWidth:     110,
  rowHeight:    44,
  minColWidth:  40,
  minRowHeight: 44,
  fontSize:     13,
  padX:         8,
  padY:         6,
};

function clamp(value, lo, hi) {
  return Math.min(hi, Math.max(lo, value));
}

function pageScale(pageW, pageH) {
  const w = parseFloat(pageW);
  const h = parseFloat(pageH);
  if (!(w > 0) || !(h > 0)) { return 1; }
  return Math.sqrt(w * h) / REF_L;
}
function TableScale(pageW, pageH, rowCount = 4, colCount = 3) {
  const w = parseFloat(pageW);
  const h = parseFloat(pageH);
  const s = pageScale(w, h);
  if (!(w > 0) || !(h > 0)) { return s; }

  const wantedW = (colCount || 1) * TABLE_REF.colWidth * s;
  const wantedH = (rowCount || 1) * TABLE_REF.rowHeight * s;
  const fit     = Math.min(
    1,
    (w * MAX_FRACTION) / (wantedW || 1),
    (h * MAX_FRACTION) / (wantedH || 1),
  );

  return clamp(s * fit, MIN_SCALE, MAX_SCALE);
}

function getTableScale(table) {
  const s = table && parseFloat(table.pageScale);
  return s > 0 ? s : 1;
}

function getTableContentScale(table) {
  const s = table && parseFloat(table.contentScale);
  return s > 0 ? s : getTableScale(table);
}

function scaledMetrics(scale) {
  const s = scale > 0 ? scale : 1;
  return {
    scale:        s,
    colWidth:     TABLE_REF.colWidth * s,
    rowHeight:    TABLE_REF.rowHeight * s,
    minColWidth:  Math.max(MIN_COL_WIDTH, TABLE_REF.minColWidth * s),
    minRowHeight: Math.max(MIN_ROW_HEIGHT, TABLE_REF.minRowHeight * s),
    fontSize:     Math.max(MIN_FONT_SIZE, TABLE_REF.fontSize * s),
    padX:         TABLE_REF.padX * s,
    padY:         TABLE_REF.padY * s,
  };
}

function tableMetrics(table) {
  return scaledMetrics(getTableContentScale(table));
}

function chromePx(px, zoomLevel) {
  const z = parseFloat(zoomLevel);
  return px / (z > 0 ? clamp(z / 100, 0.1, 10) : 1);
}

export {
  TABLE_REF,
  SCALE_FLOORS,
  pageScale,
  TableScale,
  getTableScale,
  getTableContentScale,
  scaledMetrics,
  tableMetrics,
  chromePx,
};
